import styled from '@emotion/styled';

import { Label } from '../../../../components/Typography/Typography.styles';

export const TextAreaCharCount = styled(Label)`
  color: ${(props: any) => props.theme.colors['gray-2']};
`;
